import {
  GET_SERT_PROFILE,
  GET_SERT_PROFILE_FAIL,
  GET_SERT_PROFILE_SUCCESS,
  GET_SERTS,
  GET_SERTS_FAIL,
  GET_SERTS_SUCCESS,
  ADD_NEW_SERT,
  ADD_SERT_SUCCESS,
  ADD_SERT_FAIL,
  UPDATE_SERT,
  UPDATE_SERT_SUCCESS,
  UPDATE_SERT_FAIL,
  DELETE_SERT,
  DELETE_SERT_SUCCESS,
  DELETE_SERT_FAIL,
  GET_CLASS,
  GET_CLASS_SUCCESS,
  GET_CLASS_FAIL,
} from "./actionTypes"

export const getSerts = (id) => ({
  type: GET_SERTS,
  payload: id,
})

export const getClass = (id) => ({
  type: GET_CLASS,
  payload: id,
})

export const getSertsSuccess = mainClass => ({
  type: GET_SERTS_SUCCESS,
  payload: mainClass,
})

export const getClassSuccess1 = Class => ({
  type: GET_CLASS_SUCCESS,
  payload: Class,
})

export const addNewSert = user => ({
  type: ADD_NEW_SERT,
  payload: user,
})

export const addSertSuccess = user => ({
  type: ADD_SERT_SUCCESS,
  payload: user,
})

export const addSertFail = error => ({
  type: ADD_SERT_FAIL,
  payload: error,
})

export const getSertsFail = error => ({
  type: GET_SERTS_FAIL,
  payload: error,
})



export const getSertProfile = () => ({
  type: GET_SERT_PROFILE,
})

export const getClassesSuccess = data => ({
  // type: GET_SERT_PROFILE_SUCCESS,
  // payload: userProfile,
  type: GET_CLASS_SUCCESS,
  payload: data,
})

export const getClassesFail = error => ({
  type: GET_CLASS_FAIL,
  payload: error,
})

export const updateSert = user => ({
  type: UPDATE_SERT,
  payload: user,
})

export const updateSertSuccess = user => ({
  type: UPDATE_SERT_SUCCESS,
  payload: user,
})

export const updateSertFail = error => ({
  type: UPDATE_SERT_FAIL,
  payload: error,
})

export const deleteSert = user => ({
  type: DELETE_SERT,
  payload: user,
})

export const deleteSertSuccess = user => ({
  type: DELETE_SERT_SUCCESS,
  payload: user,
})

export const deleteSertFail = error => ({
  type: DELETE_SERT_FAIL,
  payload: error,
})
